import * as React from "react";
const B3Fill = (props) => (
  <svg
    width={24}
    height={26}
    viewBox="0 0 24 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M18.2686 17.5494C19.1059 16.9996 20.2055 17.5994 20.2055 18.599V20.211C20.2055 21.798 18.9684 23.4974 17.4814 23.9973L13.4952 25.3218C12.7954 25.5593 11.6583 25.5593 10.971 25.3218L6.98485 23.9973C5.48534 23.4974 4.26074 21.798 4.26074 20.211V18.5865C4.26074 17.5994 5.36038 16.9996 6.18511 17.5369L8.75927 19.2113C9.74644 19.8736 10.996 20.1985 12.2456 20.1985C13.4952 20.1985 14.7448 19.8736 15.732 19.2113L18.2686 17.5494Z"
      fill="#276AA6"
    />
    <path
      d="M22.2026 6.0763L14.7176 1.16541C13.368 0.278198 11.1438 0.278198 9.7942 1.16541L2.27167 6.0763C-0.140037 7.63828 -0.140037 11.1746 2.27167 12.7491L4.27102 14.0487L9.7942 17.6475C11.1438 18.5347 13.368 18.5347 14.7176 17.6475L20.2033 14.0487L21.9152 12.924V16.7478C21.9152 17.2601 22.3401 17.685 22.8524 17.685C23.3648 17.685 23.7896 17.2601 23.7896 16.7478V10.5998C24.2894 8.98784 23.7771 7.11346 22.2026 6.0763Z"
      fill="#276AA6"
    />
  </svg>
);
export default B3Fill;
